{
  "appCore": {
    "common": {
      "yes": "Так",
      "no": "Ні",
      "errors": {
        "notEmpty": "Це поле не може бути порожнім"
      }
    },
    "footer": {
      "state": "умови використання",
      "policy": "політика конфіденційності"
    },
    "apps": {
      "popUp": {
        "privacyPolicy": {
          "header": "Момент, ще одне:",
          "text": "Я заявляю, що прочитав {state} та {policy} і погоджуюсь з їхніми умовами.",
          "state": "умови користування",
          "policy": "політика конфіденційності",
          "decline": "Скасувати",
          "accept": "Так, я погоджуюсь"
        }
      },
      "event": {
        "common": {
          "underPictureText": "Покажіть нам, як ви розважаєтеся, ми будемо сміятися завтра!",
          "back": "Назад"
        },
        "mirrorWedding": {
          "sendText": "НАДІСЛАТИ І ДРУКУВАТИ",
          "sendingText": "НАДСИЛАЄТЬСЯ"
        },
        "wedding": {
          "sendText": "НАДІСЛАТИ",
          "sendingText": "НАДСИЛАЄТЬСЯ",
          "1": {
            "sendText": "НАДІСЛАТИ ФОТО/ВІДЕО"
          }
        },
        "gallery": {
          "header": "Галерея нашого весілля",
          "name": "Галерея",
          "button": "Фотогалерея",
          "subtext": "перегляд завантажених фото",
          "moreFiles": "Більше фото",
          "changeView": "Змінити вигляд",
          "loadedFiles": "Фото завантажені",
          "noNewFiles": "Немає нових файлів для завантаження. Фотографії в галереї відображаються у випадковому порядку і не обов’язково з’являються в кінці."
        },
        "sender": {
          "errors": {
            "wrongFiles": "Ви можете надіслати до 20 фото або відео загальним розміром не більше 1 ГБ",
            "wrongFilesWithWish": "Ви можете надіслати максимум 1 фото загальним розміром не більше 1 ГБ",
            "default": "Помилка під час передачі файлу",
            "notFiles": "Файли не вибрано"
          },
          "infos": {
            "emptyWish": "Будь ласка, введіть ваші побажання",
            "sendedFiles": "Усі файли надіслано. Дякуємо :)",
            "sendedProcessing": "Відео з'явиться в галереї після обробки сервером",
            "fileUnsupported": "Фото успішно завантажено. Після відправки ви знайдете його в галереї.",
            "sendingProblem": {
              "sended": "Відправлено",
              "from": "з",
              "files": "файлів",
              "checkFiles": "Перевірте файл і надішліть його знову."
            }            
          },
          "button": "Надіслати фото/відео",
          "or": "або",
          "yourWishes": "Ваші побажання"
        }
      },
      "rsvp": {
        "versions": {
          "1": {
            "invitationText": "мають честь запросити",
            "placeText": "на весільну церемонію, яка відбудеться",
            "yearAndHour": "о",
            "in": "в",
            "0": {
              "placeText": "на весільну церемонію, яка відбудеться"
            },
            "1": {
              "placeText": "весільна церемонія та прийом, які відбудуться"
            },
            "2": {
              "partyText": "ВЕСІЛЬНИЙ ПРИЙОМ",
              "weddingPlace": "Дивіться церкву на карті",
              "partyPlace": "Дивіться зал на карті"
            }
          },
          "2": {
            "wedding": "Буде весілля!",
            "year": "рік",
            "hour": "о",
            "weddingPath": "Натисніть, щоб спланувати свій маршрут між церквою та весільним залом:",
            "partyWelcome": "Ми не можемо дочекатися, щоб привітати вас на нашому весіллі!"
          }
        },
        "components": {
          "form": {
            "confirmArrival": "ПІДТВЕРДІТЬ ВАШУ ПРИСУТНІСТЬ",
            "main": {
              "addAnotherGuest": "Додати ще одного гостя",
              "addGuest": "Підтвердити присутність",
              "sendRsvp": "Надіслати підтвердження",
              "edit": "РЕДАГУВАТИ",
              "name": "ІМ'Я",
              "surname": "ПРІЗВИЩЕ",
              "present": "Я буду на весіллі",
              "notPresent": "Я не буду на весіллі",
              "notify": {
                "error": "Помилка передачі даних",
                "positive": "Дані надіслані. Дякуємо :)",
                "notFilled": "Не всі обов'язкові поля заповнені"
              }
            },
            "guest": {
              "guestData": "Введіть ваше ім'я та прізвище:",
              "name": "Ім'я",
              "surname": "Прізвище",
              "willBePresent": "Чи будете ви на нашому весіллі?",
              "save": "Зберегти"
            },
            "verions": {
              "2": {
                "historyWish": "Ми б хотіли, щоб ви стали частиною нашої спільної історії.",
                "dueToInfo": "Будь ласка, підтвердьте свою присутність до {dueToTime}, заповнивши форму нижче.",
                "confirmArrival": "Підтвердження прибуття",
                "guest": {
                  "guestData": "Введіть ваше ім'я та прізвище:",
                  "willBePresent": "Ви підтверджуєте свою присутність?"
                }
              }
            }
          },
          "weddingWishes": {
            "title": "ВЕСІЛЬНІ ПОБАЖАННЯ"
          },
          "clockWidget": {
            "title": "Час до весілля",
            "clock": {
              "days": "днів",
              "hours": "годин",
              "minutes": "хвилин",
              "seconds": "секунд"
            }
          }
        }
      },
      "components": {
        "inputs": {
          "inputCheckboxTrueFalseSelect": {
            "selectLabel": "Виберіть один з наступних варіантів:"
          }
        },
        "sender": {
          "sendLabel": "Додати фото або відео",
          "sendWithWishLabel": "Додати фото та побажання",
          "from": "від",
          "processing": "Обробка",
          "notToGallery": "Не показувати в галереї"
        },
        "gks": {
          "findTable": "Знайдіть свій стіл"
        }      
      },
      "gks": {
        "header": "План столів",
        "foundPlace": "Знайдіть своє місце...",
        "namePlaceholder": "Введіть своє ім'я",
        "personNotFound": "Особу не знайдено",
        "samePersonFound": "Знайдено більше людей з подібним ім'ям, будь ласка, продовжуйте вводити...",
        "table": "Стіл",
        "footer": "...А потім гуляй до ранку!"
      }
    }
  },
  "loremIpsum": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,"
}
